module.exports = "<mat-icon svgIcon=\"left-arrow\" color=\"primary\" (click)=\"handleClick()\" class=\"app-back-button\"></mat-icon>"